const Module = () => import('./Module.vue')
const Scoreboard = () => import('./views/Scoreboard.vue')

const moduleRoute = {
  path: '/scoreboard',
  component: Module,
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: ':campaignId',
      component: Scoreboard,
      props: true
    }
  ]
}

export default router => {
  router.addRoute(moduleRoute)
}
